import React from "react";
import UserDownloadLisr from "./UserDownloadLisr";
import { Link, useNavigate } from "react-router-dom";
import { handelAdminLogin } from "../../store/features/auth/authSlice";
import { useDispatch } from "react-redux";

const AdminNavbar = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  return (
    <div>
      <div className="admin_navbar fixed_width  p-1 bg-black text-white">
        <ul className="flex justify-between text-white ">
          <div className="flex">
            <li>
              <Link className=" text-white text-[12px]" to={"/list"}>
                Download List
              </Link>
            </li>
            <li>
              <Link className="text-white text-[12px]" to={"/AdminMyAccounts"}>
                My Accounts
              </Link>
            </li>
            <li className="dropdown w-[140px]">
              <button
                className="  text-white text-[12px] dropdown-toggle scrollbar-webkit"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                My Reports
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <Link to={"/Aprofitdownline"} className="dropdown-item">
                    Profit/Loss Report by Downline
                  </Link>
                </li>
                <li>
                  <a className="dropdown-item">Another action</a>
                </li>
                <li>
                  <a className="dropdown-item">Something else here</a>
                </li>
              </ul>
            </li>

            <li>
              <Link className="text-white text-[12px]" to={"/betlist"}>
                BetList
              </Link>
            </li>
            <li>
              <Link className="text-white text-[12px]" to={"/Abetlistlive"}>
                BetListLive
              </Link>
            </li>
            <li>
              <Link className="text-white text-[12px]" to={"/ABanking"}>
                Banking
              </Link>
            </li>

            <li>
              <Link className="text-white text-[12px]" to={"/AblockMarket"}>
                Block Market
              </Link>
            </li>
            <li>
              <Link className="text-white text-[12px]" to={"/Ariskmanagement"}>
                Risk Management
              </Link>
            </li>
            <li>
              <Link
                className="text-white text-[12px]"
                to={"/Achecksportwiseresult"}
              >
                old resu.
              </Link>
            </li>
            <li>
              <Link className="text-white text-[12px]" to={"/password-history"}>
                Password Hsitory
              </Link>
            </li>
            <li>
              <button
                onClick={() => {
                  dispatch(handelAdminLogin({ adminLogin: false }));
                  navigation("/admin");
                }}
              >
                Logout
              </button>
            </li>
           
          </div>
          <div className=" items-center d-flex justify-content-end">
              <span className="text-gray-400 mx-2">Time Zone :</span>{" "}
              <li className="setting">GMT+5:30</li>
              <li className="setting flex items-center">
                settings
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  className="ml-2"
                >
                  <path
                    d="M6 8.106c.385 0 .745-.096 1.081-.289.336-.192.602-.45.8-.771a2.002 2.002 0 0 0 0-2.099 2.19 2.19 0 0 0-.8-.779A2.139 2.139 0 0 0 6 3.88c-.385 0-.743.096-1.074.288-.33.193-.594.452-.792.78a2.002 2.002 0 0 0 0 2.098c.198.322.462.579.792.771.331.193.689.289 1.074.289zm4.605-1.515l1.288.981c.06.048.094.11.104.188a.333.333 0 0 1-.044.216l-1.244 2.077a.269.269 0 0 1-.156.13.336.336 0 0 1-.214-.015l-1.526-.591c-.394.279-.745.476-1.05.591L7.54 11.74a.364.364 0 0 1-.111.188.272.272 0 0 1-.185.072H4.756a.29.29 0 0 1-.281-.26l-.237-1.572A3.752 3.752 0 0 1 3.2 9.577l-1.54.591c-.158.068-.28.03-.37-.115L.047 7.976a.333.333 0 0 1-.044-.216.278.278 0 0 1 .104-.188l1.303-.98A4.395 4.395 0 0 1 1.38 6c0-.26.01-.457.03-.591L.107 4.428a.278.278 0 0 1-.104-.188.333.333 0 0 1 .044-.216l1.244-2.077c.09-.144.212-.183.37-.115l1.54.591c.356-.26.701-.457 1.037-.591L4.475.26A.29.29 0 0 1 4.756 0h2.488c.069 0 .13.024.185.072.054.048.091.11.111.188l.222 1.572a3.87 3.87 0 0 1 1.051.591l1.526-.591a.336.336 0 0 1 .214-.015c.064.02.116.063.156.13l1.244 2.077c.04.067.054.14.044.216a.278.278 0 0 1-.104.188l-1.288.98c.02.135.03.332.03.592 0 .26-.01.457-.03.591z"
                    fill="#222"
                    fill-rule="evenodd"
                  />
                </svg>
              </li>
            </div>
        </ul>
      </div>
    </div>
  );
};

export default AdminNavbar;
